const override = false;
const config = {
    development: {
        LOCATION_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com',
        PAYMENTS_SERVICE_URL: 'http://localhost:5055',
        EMAIL_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/emails',
        PUBLIC_API_URL: 'https://public-api-dot-highlevel-staging.uc.r.appspot.com',
        PRODUCT_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com',
        INVOICE_PREVIEW_URL: 'http://localhost:3041',
        INVOICE_SERVICE_URL: 'http://localhost:5075',
        PAYMENTLINKS_SERVICE_URL: 'http://localhost:5095',
        ENVIRONMENT: 'development',
    },
    staging: {
        LOCATION_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com',
        PAYMENTS_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com',
        EMAIL_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com/emails',
        PUBLIC_API_URL: 'https://public-api-dot-highlevel-staging.uc.r.appspot.com',
        PRODUCT_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com',
        INVOICE_PREVIEW_URL: 'https://link.staging.fastpaydirect.com',
        INVOICE_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com',
        PAYMENTLINKS_SERVICE_URL: 'https://staging.backend.leadconnectorhq.com',
        ENVIRONMENT: 'staging',
    },
    production: {
        LOCATION_SERVICE_URL: 'https://backend.leadconnectorhq.com',
        PAYMENTS_SERVICE_URL: 'https://backend.leadconnectorhq.com',
        EMAIL_SERVICE_URL: 'https://backend.leadconnectorhq.com/emails',
        PUBLIC_API_URL: 'https://rest.gohighlevel.com',
        PRODUCT_SERVICE_URL: 'https://backend.leadconnectorhq.com',
        INVOICE_PREVIEW_URL: 'https://link.fastpaydirect.com',
        INVOICE_SERVICE_URL: 'https://backend.leadconnectorhq.com',
        PAYMENTLINKS_SERVICE_URL: 'https://backend.leadconnectorhq.com',
        ENVIRONMENT: 'production',
    },
};
if (override) {
    // do overrides here
}
export default config[process.env.mode];
